/**
 * Hours as a number a sentence can hold. Arabic counts change their noun with the number
 * (ساعة, ساعتين, 3–10 ساعات, 11+ ساعة), so in Arabic the number comes back with its noun and
 * the sentence around it says what the hours are for ("5 ساعات فيديو للمقاطع والكابشن في
 * الشهر"); "5 ساعة تجهيز فيديو" was both a wrong plural and a word-for-word "video processing"
 * (the user, 2026-10-03). Every other language gets the number as it was.
 */
export function countHours(n, locale) {
  if (locale !== 'ar') return n;
  const value = Number(n);
  if (value === 1) return 'ساعة';
  if (value === 2) return 'ساعتين';
  if (Number.isInteger(value) && value >= 3 && value <= 10) return `${value} ساعات`;
  return `${n} ساعة`;
}

/** The noun alone, after a number shown on its own (the pricing slider's animated total). */
export function hoursNoun(n, locale, fallback) {
  if (locale !== 'ar') return fallback;
  const value = Number(n);
  return Number.isInteger(value) && value >= 3 && value <= 10 ? 'ساعات' : 'ساعة';
}

/** Months the same way: in Arabic the number with its noun (شهر, شهرين, 3–10 شهور, 11+ شهر). */
export function countMonths(n, locale) {
  if (locale !== 'ar') return n;
  const value = Number(n);
  if (value === 1) return 'شهر';
  if (value === 2) return 'شهرين';
  if (Number.isInteger(value) && value >= 3 && value <= 10) return `${value} شهور`;
  return `${n} شهر`;
}
